<template>
    <GridContainer>
        <GridRow>
            <GridCol bp="sm" size="6" style="padding: 15px">
                <Label>{{ $t('calc.iWantToWithdraw') }}</Label>
                <Input
                    :value="sum"
                    :update="onInputUpdate"
                    :hook="getResult"
                    :placeholder="$t('calc.enterAmount')"
                />
            </GridCol>

            <GridCol bp="sm" size="6" style="padding: 15px">
                <Label>{{ $t('calc.inCurrency') }}</Label>
                <Select
                    :list="payoutCurrencyList"
                    :active="currencyActiveItem"
                    :update="onSelectCurrency"
                    :placeholder="$t('calc.chooseCurrency')"
                    :disabled="currencyListIsLoading"
                />
            </GridCol>
        </GridRow>

        <GridRow>
            <GridCol bp="sm" size="6" style="padding: 15px">
                <Label>{{ $t('calc.paymentMethod') }}</Label>
                <Select
                    :list="payoutPayList"
                    :active="payListActiveItem"
                    :update="onSelectPay"
                    :placeholder="$t('calc.choosePayMethod')"
                    :disabled="payListIsLoading"
                />
            </GridCol>

            <GridCol bp="sm" size="6" style="padding: 15px">
                <Label>{{ $t('calc.accountIncome') }}</Label>
                <div
                    class="result"
                    :class="[ (!!result && !!sum.length) || resultIsLoading ? '_result' : '' ]"
                >
                    {{ resultIsLoading ? $t('calc.loading') : (!!result && !!sum.length && `${ result } ${ payoutCurrencyList[currencyActiveItem].title }`) || '—' }}
                </div>
            </GridCol>
        </GridRow>
    </GridContainer>
</template>


<script>
import { mapGetters } from 'vuex'
import { ACTIONS } from '../../store/calc'

import GridContainer from '../../components/layout/gridContainer.vue'
import GridRow from '../../components/layout/gridRow.vue'
import GridCol from '../../components/layout/gridCol.vue'

import Input from './input.vue'
import Label from './label.vue'
import Select from './select.vue'


export default {
    name: 'PayOut',

    components: {
        GridContainer,
        GridRow,
        GridCol,

        Input,
        Label,
        Select,
    },

    computed: {
        ...mapGetters([
            'sum',
            'payoutPayList',
            'payoutCurrencyList',
            'payListIsLoading',
            'currencyListIsLoading',
            'payListActiveItem',
            'currencyActiveItem',
            'result',
            'resultIsLoading',
        ]),
    },

    mounted() {
        this.$store.dispatch(ACTIONS.FETCH_PAYOUT_PAYLIST)
        this.$store.dispatch(ACTIONS.FETCH_PAYOUT_CURRENCYLIST)
    },

    methods: {
        getResult() {
            this.$store.dispatch(ACTIONS.PAYOUT_FETCH_RESULT)
        },

        onInputUpdate(event) {
            const { value } = event.target

            this.$store.dispatch(ACTIONS.UPDATE_SUM, value)
        },

        onSelectCurrency(index) {
            this.$store.dispatch(ACTIONS.SET_CURRENCYLIST_ACTIVE_ITEM, index)
            this.getResult()
        },

        onSelectPay(index) {
            this.$store.dispatch(ACTIONS.SET_PAYLIST_ACTIVE_ITEM, index)
            this.getResult()
        },
    },
}
</script>


<style lang='scss' scoped>
.result {
    font-size: 34px;
    font-weight: 300;
    line-height: 1.5;
    min-height: 45px;
    color: rgba(68, 68, 68, 1);
    user-select: none;

    &._result {
        color: rgba(245, 125, 7, 1);
    }
}
</style>
